// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandBanner_container__fCbPS","chanelStripe":"BrandBanner_chanelStripe__WewFG","chanel":"BrandBanner_chanel__a_iqR","banner":"BrandBanner_banner__78M_W"};